import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import "../../assets/css/scss/section/player/_playerImageTitleHoriz.scss";
import preventRightClick from "../../common/preventRightClick";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";
import { BASEBALL_SIMILAR_PLAYERS } from "../../constant/match";

export default function PlayerImageTitleHoriz(props: any) {
    const [redirectUrl, setRedirectUrl] = useState("")
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLang = globalState?.selectedLang || "";
    console.log("PlayerImageTitleHoriz >", props)
    const clickOnButton = (redirect: any) => {
        if (redirect) {
            setRedirectUrl("/player/" + redirect)
        }
    }
    return (
        <div className="player-img-horiz">
            {redirectUrl ?
                <Redirect to={redirectUrl} />
                : null}
            <Card>
                <div className="thumbnail-img position-relative" onContextMenu={(e) => preventRightClick(e)}>
                    <Card.Img variant="top" src={props?.player_image || "/assets/images/player-img-1.png"} />
                    <h4 className="stoke text-uppercase">{props?.player_name ? props?.player_name.split(" ")[0] : ""}</h4>
                </div>
                <Card.Body>
                    <Card.Title className="bold text-uppercase">{props?.player_name}</Card.Title>
                    <Card.Text className="font-14 line-clamp-2">
                        {props?.player_overview}
                    </Card.Text>
                    <Button variant="primary" className="bold" onClick={() => clickOnButton(props?.identifier)}>
                        {BASEBALL_SIMILAR_PLAYERS[selectedLang]['link_text']}
                    </Button>
                </Card.Body>
            </Card>
        </div>
    );
}
